import {Part} from "../part";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PartMenuType} from "../../../visComponents/constants";
import {LayoutType, ShowerComboTubType} from "../constants";
import { showerTubComboThumbnail, custom60in30X8Shower } from '../../../bvComponent/core/assets';

import BathTubLiner from "../subparts/showerTubCombo/bathtubLiner";
import ReplacementTub from "../subparts/showerTubCombo/replacementTub";
import WalkInTub from "../subparts/showerTubCombo/walkInTub";
import JettedTub from "../subparts/showerTubCombo/jettedTub";
import WallConfiguration from "../subparts/showerTubCombo/wallConfiguration";
import {fixDbFeatureProperties} from "../../../../misc/helpers";
import WalkInTubFixture from "../subparts/showerTubCombo/walkInTubFixture";
import ReplacementTubFixture from "../subparts/showerTubCombo/replacementTubFixture";
import TubLiner from "../subparts/showerTubCombo/tubLiner";
import TubSpout from "../subparts/showerTubCombo/tubSpout";

export class ShowerTubCombo extends Part {
  static id = 'Shower Tub Combo';

  constructor() {
    super(true, false, PartMenuType.Complex);

    this.showerTubComboIsActive = false;  // param needed to check if shower is still active or not
    this.menuType = PartMenuType.Complex;
    this.partThumbnail = showerTubComboThumbnail;
    this.partName = 'Shower Tub Combo';
    this.translateId = "visualizer.bathroom.shower_tub_combo";
    this.relatedItems = [];
    this.wallConfiguration = null;
    this.bathTubLiner = null;
    this.tubLiner = null;
    this.tubSpout = null;
    this.replacementTub = null;
    this.replacementTubFixture = null;
    this.walkInTub = null;
    this.jettedTub = null;

    // Kohler hardcode, they don't have bathtub_liner
    this.bottomTub = ShowerComboTubType.replacement_tub;
    this.leftShowerWallType = 'Pony';
    this.showerComboSize = '60in';
    this.relatedGroupNames = ["Bathtub Liner", "Tub Liner", "Replacement Tub", "Walk In Tub", "Jetted Tub",
      "Replacement tub Fixture", "Tub Spout"];
  }

  load(dbFeature, loadFeature = true) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Bathtub Liner":
        relatedItemName = "bathTubLiner";
        RelatedItemClass = BathTubLiner;
        break;
      case "Tub Liner":
        relatedItemName = "tubLiner";
        RelatedItemClass = TubLiner;
        break;
      case "Replacement Tub":
        relatedItemName = "replacementTub";
        RelatedItemClass = ReplacementTub;
        break;
      case "Walk In Tub Fixture":
        relatedItemName = "walkInTubFixture";
        RelatedItemClass = WalkInTubFixture;
        break;
      case "Replacement tub Fixture":
      case "Replacement Tub Fixture":
        relatedItemName = "replacementTubFixture";
        RelatedItemClass = ReplacementTubFixture;
        break;
      case "Walk In Tub":
      case "Walk in Tub":
        relatedItemName = "walkInTub";
        RelatedItemClass = WalkInTub;
        break;
      case "Jetted Tub":
        relatedItemName = "jettedTub";
        RelatedItemClass = JettedTub;
        break;
      case "Tub Spout":
        relatedItemName = "tubSpout";
        RelatedItemClass = TubSpout;
        break;
    }
    return this.loadCommon(relatedItemName, RelatedItemClass, dbFeature, loadFeature)
  }

  setSpecificRules() {
    if (!this.wallConfiguration) {
      this.wallConfiguration = new WallConfiguration(true);
      this.wallConfiguration.counts = {
        allLayoutFeaturesCount: 0,
        largeLayoutFeaturesCount: 0,
        smallLayoutFeaturesCount: 0
      };
      this.relatedItems.unshift(this.wallConfiguration);
      this.wallConfiguration.getParent = () => this;
    }
    const wallConfigurations = [
      // ShowerTubCombo.createCustomWallConfiguration(
      //   custom60inPonyShower,
      //   "Pony Wall 60in",
      //   "Pony",
      //   "60in",
      //   {
      //     "ShowerSize": ['60in'],
      //     "CountertopSize": ["20in", "24in", "30in", "36in", "48in", "60in", "72in"],
      //   },
      //   this,
      //   100000
      // ),
      ShowerTubCombo.createCustomWallConfiguration(
        custom60in30X8Shower,
        "Full Wall 60in",
        "30X8",
        "60in",
        {
          "ShowerSize": ['60in'],
          "CountertopSize": ["20in", "24in", "30in", "36in", "48in", "60in", "72in"],
        },
        this,
        100001
      ),
    ];
    Object.keys(LayoutType).forEach(layoutType => {
      this.wallConfiguration.featuresList[layoutType] = wallConfigurations;
      if (this.wallConfiguration.counts) {
        this.wallConfiguration.counts[layoutType.toLowerCase() + "LayoutFeaturesCount"]++;
      }
    });
  }

  static createCustomWallConfiguration(customThumbnail, name, leftShowerWallType, showerComboSize, metaData, parent, id) {
    const conf = new WallConfiguration();
    conf.partName = name;
    conf.showerBodyId = name.toLowerCase().replace(/ /gi, "-");
    conf.dbFeature = {};
    conf.featureName = name;
    conf.groupName = "Wall Configuration";
    conf.showerComboSize = showerComboSize;
    // conf.parent = parent;
    conf.getParent = () => parent.wallConfiguration;
    conf.metaData = metaData;
    conf.leftShowerWallType = leftShowerWallType;
    conf.customThumbnail = customThumbnail;
    conf.dbFeature = fixDbFeatureProperties({
      metaData,
      id,
      unlocked: true
    });
    return conf;
  }

  setLayers(layout, placeholdersNeeded) {

    if (!this.showerTubComboIsActive && !(this.bottomTub === "replacement_tub" &&
      this.replacementTub?.canRenderStandAloneReplacementTub?.())) {
      return null
    }

    return super.setLayers(layout, placeholdersNeeded)
  }

  subParts() {

    let subParts = [
      ...this.getRelatedItems().filter(item => item.visible).map(_ => new DesignNavigationItem(_.partName, _)),
      ...this.layout.parts.Shower.subParts().filter(subPart => {
        return (subPart.text === "Fixture")
          || (subPart.text === "Shower Head")
          || (subPart.text === "Shower Walls")
          || (subPart.text === "Shower Walls Accent")
          || (subPart.text === "Shower Door")
          || (subPart.text === "Handle")
          || (subPart.text === "Pony Wall")
          || (subPart.text === "Pony Wall Cap")
          || (subPart.text === "Pony Wall Glass")
      })
    ];

    if (this.bottomTub === ShowerComboTubType.walk_in_tub) {
      subParts = subParts.filter(subPart => {
        return subPart.part.partId !== "shower_door" && subPart.part.partId !== "shower_door_handle" && subPart.part.partId !== "shower_fixture"
      })
    }

    return subParts
  }

  getShowerRelatedItems() {
    return this.layout.parts.Shower.getRelatedItems().filter(relItem => {
      return (relItem.partId === "shower_fixture")
        || (relItem.partId === "shower_head")
        || (relItem.partId === "shower_wall")
        || (relItem.partId === "shower_wall_accent")
        || (relItem.partId === "shower_door")
        || (relItem.partId === "shower_door_handle")
        || (relItem.partId === "pony_wall")
        || (relItem.partId === "pony_wall_cap")
        || (relItem.partId === "pony_wall_glass")
    })
  }

  setShowerTubCombo() {
    this.showerTubComboIsActive = true;
  }

  isSubTypeWithItems() {
    return false
  }

  handleSubPartClick() {}

  setZIndex(zIndexes) {
    if (!this.showerTubComboIsActive) {
      return null
    }

    if(zIndexes)
      this.relatedItems.forEach(_ => _.setZIndex(zIndexes));
  }

  setActiveTub(bottomTub) {
    this.bottomTub = bottomTub;
  }

  showerSize() {
    return this.showerComboSize
  }

  showerDimensions() {
    return this.leftShowerWallType
  }

  setShowerSize(leftShowerWallType, showerComboSize) {
    this.leftShowerWallType = leftShowerWallType;
    this.showerComboSize = showerComboSize;
  }

  freeStandingTubActive(skipDisabledCheck = false) {
    if (!this.showerTubComboIsActive || (this.bottomTub !== ShowerComboTubType.replacement_tub)) {
      return false;
    }
    if (this.layout?.type !== 11 ) {
      return false; // on layout 18 we also have MountType D, but they are rendered in the Shower area
    }
    return this.replacementTub?.activeFeature && (!this.replacementTub.disabled || skipDisabledCheck)
      && this.replacementTub.isStandaloneReplacementTub?.();
  }

}
